import React from "react";
import Typography from "@material-ui/core/Typography";
import { getResultSpotName } from "../../util/GetResultSpotName";
import { withTheme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import ForwardIcon from "@material-ui/icons/ArrowForward";
import { languages } from "../../constants/languages";
import Select from "@material-ui/core/Select";

const NextFasePoules = (props) => (
  <div style={{ paddingRight: 15 }}>
    {props.poules
      .filter(
        (poule) =>
          poule.fase === Number(props.nextFase.id) &&
          poule.division === props.division.id &&
          poule.bracket === null
      )
      .concat(
        props.brackets.filter(
          (bracket) =>
            bracket.fase === Number(props.nextFase.id) &&
            bracket.division === props.division.id &&
            !bracket.subBracketTo
        )
      )
      .sort((a, b) => {
        if (a.indexNum > b.indexNum) {
          return 1;
        } else if (a.indexNum < b.indexNum) {
          return -1;
        } else {
          return a.num - b.num;
        }
      })
      .map((el) => {
        if (el.isBracket) {
          return (
            <Paper key={el.id} style={{ marginBottom: 15, overflow: "hidden" }}>
              <div
                style={{
                  background: props.theme.palette.primary.main,
                  display: "flex",
                  alignItems: "center",
                  height: 30,
                  paddingLeft: 10,
                  paddingRight: 10,
                }}
              >
                <Typography style={{ color: "white", fontWeight: 500 }}>
                  {el.name}
                </Typography>
              </div>
              <div style={{ padding: "15px 15px 1px 15px" }}>
                {props.poules
                  .filter(
                    (p) =>
                      p.bracket === el.id &&
                      p.bracketRound === el.size &&
                      !p.losersFinal
                  )
                  .sort((a, b) => a.num - b.num)
                  .map((p) => (
                    <Paper
                      key={p.id}
                      style={{ marginBottom: 15, overflow: "hidden" }}
                    >
                      <div
                        style={{
                          background: props.theme.palette.primary.main,
                          display: "flex",
                          alignItems: "center",
                          height: 30,
                          paddingLeft: 10,
                          paddingRight: 10,
                        }}
                      >
                        <Typography style={{ color: "white", fontWeight: 500 }}>
                          {p.name}
                        </Typography>
                      </div>
                      <div style={{ padding: "5px 10px 5px 10px" }}>
                        {Object.keys(props.nextFaseDivision[p.id] || {})
                          .length === 0 && (
                          <div style={{ width: 250, whiteSpace: "normal" }}>
                            <Typography>
                              {languages.formatString(
                                languages.results.noTeams,
                                props.tournament.individualPlayers
                                  ? languages.teams.playersLow
                                  : languages.tournament.teamsLow
                              )}
                            </Typography>
                          </div>
                        )}
                        {p.status0 === "bye" &&
                          Object.keys(props.nextFaseDivision[p.id] || {})
                            .length !== 0 && (
                            <Typography>{languages.structure.bye}</Typography>
                          )}
                        {Object.keys(props.nextFaseDivision[p.id] || {})
                          .sort(
                            (a, b) =>
                              props.nextFaseDivision[p.id][a].resultSpot[
                                "numInPoule" + props.nextFase.id
                              ] -
                              props.nextFaseDivision[p.id][b].resultSpot[
                                "numInPoule" + props.nextFase.id
                              ]
                          )
                          .map((key) => {
                            let rs = props.nextFaseDivision[p.id][key];
                            return (
                              <div
                                key={key}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Typography>
                                  {getResultSpotName(
                                    rs.resultSpot,
                                    props.resultSpotsAll,
                                    props.poulesByKey,
                                    props.divisionsObject
                                  )}
                                </Typography>

                                <ForwardIcon
                                  style={{
                                    height: 21,
                                    marginLeft: 6,
                                    marginRight: 6,
                                  }}
                                />
                                <Select
                                  value={rs.teamId}
                                  onChange={(e) => {
                                    props.handleDivisionChange(e, p.id, key);
                                  }}
                                  inputProps={{
                                    name: "",
                                    id: "",
                                  }}
                                >
                                  {props.menuItems}
                                </Select>
                              </div>
                            );
                          })}
                        {p.status1 === "bye" &&
                          Object.keys(props.nextFaseDivision[p.id] || {})
                            .length !== 0 && (
                            <Typography>{languages.structure.bye}</Typography>
                          )}
                      </div>
                    </Paper>
                  ))}
              </div>
            </Paper>
          );
        } else {
          return (
            <Paper key={el.id} style={{ marginBottom: 15, overflow: "hidden" }}>
              <div
                style={{
                  background: props.theme.palette.primary.main,
                  display: "flex",
                  alignItems: "center",
                  height: 30,
                  paddingLeft: 10,
                  paddingRight: 10,
                }}
              >
                <Typography style={{ color: "white", fontWeight: 500 }}>
                  {el.name}
                </Typography>
              </div>
              <div style={{ padding: "5px 10px 5px 10px" }}>
                {Object.keys(props.nextFaseDivision[el.id] || {}).length ===
                  0 && (
                  <div style={{ width: 250, whiteSpace: "normal" }}>
                    <Typography>
                      {languages.formatString(
                        languages.results.noTeams,
                        props.tournament.individualPlayers
                          ? languages.teams.playersLow
                          : languages.tournament.teamsLow
                      )}
                    </Typography>
                  </div>
                )}
                {Object.keys(props.nextFaseDivision[el.id] || {})
                  .sort(
                    (a, b) =>
                      props.nextFaseDivision[el.id][a].resultSpot[
                        "numInPoule" + props.nextFase.id
                      ] -
                      props.nextFaseDivision[el.id][b].resultSpot[
                        "numInPoule" + props.nextFase.id
                      ]
                  )
                  .map((key) => {
                    let rs = props.nextFaseDivision[el.id][key];
                    return (
                      <div
                        key={key}
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Typography>
                          {getResultSpotName(
                            rs.resultSpot,
                            props.resultSpotsAll,
                            props.poulesByKey,
                            props.divisionsObject
                          )}
                        </Typography>

                        <ForwardIcon
                          style={{
                            height: 21,
                            marginLeft: 6,
                            marginRight: 6,
                          }}
                        />
                        <Select
                          value={rs.teamId}
                          onChange={(e) => {
                            props.handleDivisionChange(e, el.id, key);
                          }}
                          inputProps={{
                            name: "",
                            id: "",
                          }}
                        >
                          {props.menuItems}
                        </Select>
                      </div>
                    );
                  })}
              </div>
            </Paper>
          );
        }
      })}
  </div>
);

export default withTheme(NextFasePoules);
